  $(document).ready(function(){
    $(".set-2 .custom-options .custom-swatch:nth-child(2)").addClass("active");
    $(".set-2 .custom-swatch").on("click",function(){
     $(this).addClass("active").siblings().removeClass("active");
      var l1 = $(".set-2 .swatches-wrapper .custom-options").length;
       if(l1 == 1)
       {
         var opt = $(this).attr("data-val");
         var vrnt = $(".product-form__variants1").find("option[data-val='"+opt+"']").val();
         $(".product-form__variants1").val(vrnt).trigger("change");
       }
    });
    $(".set-1 .custom-options .custom-swatch:nth-child(2)").addClass("active");
    let option = $(".set-1 .custom-options .custom-swatch:nth-child(2)").attr("data-val");
    let variant = $(".product-form__variants").find("option[data-val='"+option+"']").val();
    $(".product-form__variants").val(variant).trigger("change");
    $(".set-1 .custom-swatch").on("click",function(){
     $(this).addClass("active").siblings().removeClass("active");
      var l1 = $(".set-1 .swatches-wrapper .custom-options").length;
       if(l1 == 1)
       {
         var opt = $(this).attr("data-val");
         var vrnt = $(".product-form__variants").find("option[data-val='"+opt+"']").val();
         $(".product-form__variants").val(vrnt).trigger("change");
       }
    });

    // $(".add-to-cart").removeAttr("disabled").text("add to cart");

    $(".variant-out-of-stock").hide();

    var identity = Math.floor((Math.random() * 1000) + 1);
    $("#random-set").val(identity);
    // setTimeout(() => {
    //   if ($('#ptw-wrapin')) {
    //     $('#ptw-wrapin .ptw-app-gnote').append('<input id="giftwrap-identity" type="hidden" name="properties[identity]" form="add-to-cart-form" class="stop-mega-menu-reinit">');
    //     // $('#ptw-wrapin .ptw-app-gnote').append('<input id="giftwrap-id" type="hidden" name="id[]" form="add-to-cart-form" class="stop-mega-menu-reinit">');
    //     // $('#ptw-wrapin .ptw-app-gnote').append('<input id="giftwrap-product-name" type="hidden" name="properties[Product Name]" form="add-to-cart-form" class="stop-mega-menu-reinit">');
    //     // $('#ptw-wrapin .ptw-app-gnote').append('<input id="giftwrap-note" type="hidden" name="properties[Gift Note]" form="add-to-cart-form" class="stop-mega-menu-reinit">');
    //     $('#giftwrap-identity').val(identity);
    //     // document.addEventListener('click', function(event) {
    //     //   // Check if the clicked element matches the selector
    //     //   console.log(event.target)
    //     //   if (event.target.matches('.ptw-gift-options-img') || event.target.matches('.ptw-gift-option-custom')) {
    //     //       // Trigger your function or action here
    //     //       let parentEl = event.target.closest('.ptw-gift-options-img');
    //     //       if (parentEl){
    //     //         document.querySelector('#giftwrap-id').value = parentEl.getAttribute('value');
    //     //       }
    //     //   }
    //     // });
    //     // document.addEventListener('input', function(event) {
    //     //   // Check if the clicked element matches the selector
    //     //   if (event.target.matches('#ptw-text-message')) {
    //     //       // Trigger your function or action here
    //     //       document.querySelector('#giftwrap-note').value = event.target.value;
    //     //   }
    //     // });
    //     // document.querySelector('.ptw-gift-options-img').addEventListener('click', () => {
    //     //   document.querySelector('.giftwrap-id').value = document.querySelector('.ptw-gift-options-img').getAttribute('value');
    //     // })
    //     // document.querySelector('#ptw-text-message').addEventListener('input', () => {
    //     //   document.querySelector('#giftwrap-note').value = document.querySelector('#ptw-text-message').value;
    //     // })
    //     console.info($('#giftwrap-identity'));
    //     console.info($('#giftwrap-identity').val());
    //   }
    // }, 1000)

    $(".product-form__variants1").on("change",function(){
      var vl = $(this).val();
      var price = $(this).siblings(".vriant-price").find("div[data-id='"+vl+"']").text();
      $(".price-set2 .money").text(price);
      var set1_price = $(".price-set1").text();
      var crncy = $(".currency-picker").val();
      if(crncy == 'AED')
      {
         var sm = "Dhs.";
      }
      else if(crncy == 'USD')
      {
        var sm = "$";
      }
      else if(crncy == 'GBP')
      {
        var sm = "£";
      }
      else if(crncy == 'EUR')
      {
        var sm = "€";
      }
      else if(crncy == 'AUD')
      {
        var sm = "$";
      }
      else if(crncy == 'SAR')
      {
        var sm = "SR";
      }
      else
      {
        var sm = "KD";
      }

      var sm = "Dhs.";

      // set1_price = set1_price.replace(sm,"");
      // var set1 = set1_price.replace(/\,/g, '');

      // var set2_price = $(".price-set2").text();

      // set2_price = set2_price.replace(sm,"");
      // var set2 = set2_price.replace(/\,/g, '');

      var set1_price = $(".price-set1").attr("data-money");
      var set1 = set1_price.replace(/\,/g, '');
      var set2_price = $(".price-set2").attr("data-money");
      var set2 = set2_price.replace(/\,/g, '');


      var fnl = parseFloat(set1) + parseFloat(set2);
      $(".total-set-price .money").remove();
      $(".total-set-price").append("<span class='money'>"+sm+" "+fnl.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+"</span>");

      var set1_cmprice = $(".compare-price-set1").attr("data-money");

      var set2_cmprice = $(".compare-price-set2").attr("data-money");

      if(set1_cmprice != undefined && set2_cmprice != undefined)
      {
        var cmset1 = set1_cmprice.replace(/\,/g, '');
        var cmset2 = set2_cmprice.replace(/\,/g, '');

        var cmfnl = parseFloat(cmset1) + parseFloat(cmset2);

        $(".total-set-price").append("<span class='total-compare money'>"+sm+" "+cmfnl.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+"</span>");
      }
      if((typeof Currency !== "undefined" && typeof Currency.moneyFormats !== "undefined") || (typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") && typeof mlvedaload !== "undefined" ) {
       mlvedaload();
      }
    });

    $(".product-form__variants").on("change",function(){
     // setTimeout(function(){
      var vl = $(this).val();
      var price = $(this).siblings(".vriant-price").find("div[data-id='"+vl+"']").text();
      $(".price-set1 .money").text(price);

      // var vl = $("#price-field .money").text();
      // $(".price-set1").html('<span class="money">'+vl+'</span>');

      var crncy = $(".currency-picker").val();
      if(crncy == 'AED')
      {
         var sm = "Dhs.";
      }
      else if(crncy == 'USD')
      {
        var sm = "$";
      }
      else if(crncy == 'GBP')
      {
        var sm = "£";
      }
      else if(crncy == 'EUR')
      {
        var sm = "€";
      }
      else if(crncy == 'AUD')
      {
        var sm = "$";
      }
      else if(crncy == 'SAR')
      {
        var sm = "SR";
      }
      else
      {
        var sm = "KD";
      }

      var sm = "Dhs.";

      // var set1_price = $(".price-set1").text();
      // set1_price = set1_price.replace(sm,'');
      // var set1 = set1_price.replace(/\,/g, '');

      // var set2_price = $(".price-set2").text();
      // set2_price = set2_price.replace(sm,'');
      // var set2 = set2_price.replace(/\,/g, '');

      var set1_price = $(".price-set1").attr("data-money");
      var set1 = set1_price.replace(/\,/g, '');
      var set2_price = $(".price-set2").attr("data-money");
      var set2 = set2_price.replace(/\,/g, '');

      var fnl = parseFloat(set1) + parseFloat(set2);
      $(".total-set-price .money").remove();
      $(".total-set-price").append("<span class='money'>"+sm+" "+fnl.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+"</span>");
      var set1_cmprice = $(".compare-price-set1").attr("data-money");

      var set2_cmprice = $(".compare-price-set2").attr("data-money");

      if(set1_cmprice != undefined && set2_cmprice != undefined)
      {
        var cmset1 = set1_cmprice.replace(/\,/g, '');
        var cmset2 = set2_cmprice.replace(/\,/g, '');

        var cmfnl = parseFloat(cmset1) + parseFloat(cmset2);

        $(".total-set-price").append("<span class='total-compare money'>"+sm+" "+cmfnl.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+"</span>");
      }
      if((typeof Currency !== "undefined" && typeof Currency.moneyFormats !== "undefined") || (typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") && typeof mlvedaload !== "undefined" ) {
       mlvedaload();
      }
	 // }, 100);
    });

    document.querySelector('.add-to-cart').removeAttribute('disabled');
    document.querySelector('.add-to-cart').textContent = 'add to cart';

  });
  function prc(){
    var crncy = $(".currency-picker").val();
      if(crncy == 'AED')
      {
         var sm = "Dhs.";
      }
      else if(crncy == 'USD')
      {
        var sm = "$";
      }
      else if(crncy == 'GBP')
      {
        var sm = "£";
      }
      else if(crncy == 'EUR')
      {
        var sm = "€";
      }
      else if(crncy == 'AUD')
      {
        var sm = "$";
      }
      else if(crncy == 'SAR')
      {
        var sm = "SR";
      }
      else
      {
        var sm = "KD";
      }

    var sm = "Dhs.";

  	// var set1_price = $(".price-set1").text();
   //  set1_price = set1_price.replace(sm,'');
   //  var set1 = set1_price.replace(/\,/g, '');
   //  console.log(set1);
   //  var set2_price = $(".price-set2").text();
   //  set2_price = set2_price.replace(sm,'');
   //  var set2 = set2_price.replace(/\,/g, '');
   //  console.log(set2);

    var set1_price = $(".price-set1").attr("data-money");
    var set1 = set1_price.replace(/\,/g, '');
    var set2_price = $(".price-set2").attr("data-money");
    var set2 = set2_price.replace(/\,/g, '');



    var fnl = parseFloat(set1) + parseFloat(set2);
    $(".total-set-price .money").remove();
    $(".total-set-price").append("<span class='money'>"+sm+" "+fnl.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+"</span>");

    var set1_cmprice = $(".compare-price-set1").attr("data-money");

    var set2_cmprice = $(".compare-price-set2").attr("data-money");

    if(set1_cmprice != undefined && set2_cmprice != undefined)
    {
      var cmset1 = set1_cmprice.replace(/\,/g, '');
      var cmset2 = set2_cmprice.replace(/\,/g, '');

      var cmfnl = parseFloat(cmset1) + parseFloat(cmset2);

      $(".total-set-price").append("<span class='total-compare money'>"+sm+" "+cmfnl.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")+"</span>");
    }
    if((typeof Currency !== "undefined" && typeof Currency.moneyFormats !== "undefined") || (typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") && typeof mlvedaload !== "undefined" ) {
     mlvedaload();
    }
  }
  prc();



  $(".custom-gift-wrap .gift-heading").on("click",function(){
  	$(this).siblings(".gift-options").slideToggle("slow");
  });

  $(".gift-item input[type=checkbox]").on("click",function(){
   $(this).prop("checked",true);
   $(".gift-msg").show();
   $(this).parent(".gift-item").siblings().find("input[type=checkbox]").prop("checked",false);
  });


//   $("#purchase").on("click",function(){
//     $(".gift-item").each(function(){
//       var input = $(this).find("input[type='checkbox']");
//       if(input.is(":checked"))
//       {
//         var title = input.attr("data-title");
//         var id = input.attr("data-id");
//         var note = $(".gift-msg-note").val();
//         if(note = '')
//         {
//           var Props1 = {'Product Name': title, 'Gift Note': note };
//         }else{
//           var Props1 = {'Product Name': title };
//         }

//         var Params1 = {
//           type: 'POST',
//           url: '/cart/add.js',
//           data: { items: [{ quantity: 1, id: id, properties: Props1 }] },
//           dataType: 'json',
//           cache : false,
//           async: false
//         };
//         $.ajax(Params1).done(function(data){
//           console.log('Gift Wrap Added');
//         });
//       }
//     });
//   });


// tabby

function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if (name == cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }

    // Return null if not found
    return null;
}


const tbby = setInterval(callTabby, 1000);
var tabby1 = 0;

function callTabby(){
  var cl = $(".nice-select").length;
  if(cl >= 1)
  {
    clearInterval(tbby);
    var fiyat = '';
    var parabirim = getCookie("acscurrency");
    var fiyatverisi = $(".total-set-price .money").html();

    if (parabirim == "AED") {
        fiyats = fiyatverisi.split(" ");
        fiyat = fiyats[1].replace(",","");
        if (fiyat > 10 && fiyat < 2001) {
            $("#tabbyPromo").show();
        }
    } else if (parabirim == "SAR") {
        fiyats = fiyatverisi.split(" ");
        fiyat =fiyats[0].replace(",","");
        if (fiyat > 10 && fiyat < 2001) {
            $("#tabbyPromo").show();
        }
    } else {
        $("#tabbyPromo").hide();
    }

      if(fiyat != '')
      {
       tabby1 =  new TabbyPromo({
            selector: '#tabbyPromo', // required, content of Tabby Promo Snippet will be placed in element with that selector
            currency: parabirim,
            price: fiyat, // required, price or your product
            lang: 'EN' // optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag
        });
      }

  }
}

$(document).on("click",".nice-select li",function(){
    var c = $(this).attr('data-value');
     setTimeout(function(){
      pr = $(".total-set-price .money").html();

        if (c == "AED") {
            fiyats = pr.split(" ");
            fiyat = fiyats[1].replace(",","");
            if (fiyat > 10 && fiyat < 2001) {
                $("#tabbyPromo").show();
            }
        } else if (c == "SAR") {
            fiyats = pr.split(" ");
            fiyat =fiyats[0].replace(",","");
            if (fiyat > 10 && fiyat < 2001) {
                $("#tabbyPromo").show();
            }
        } else {
            $("#tabbyPromo").hide();
        }
        if(fiyat != undefined)
        {
         tabby1 = new TabbyPromo({
              selector: '#tabbyPromo', // required, content of Tabby Promo Snippet will be placed in element with that selector
              currency: c,
              price: fiyat, // required, price or your product
              lang: 'EN' // optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag
          });
        }
      }, 100);
});


  // fiyatverisi = $(".total-set-price .money").html();
  // fiyats = fiyatverisi.split(" ");
  // fiyat = fiyats[1].replace(",","");
  // console.log("bak="+fiyat);
  // if (fiyat > 10 && fiyat < 2001) {
  //   $("#tabbyPromo").show();
  // }


  // setTimeout(function(){
  //  var text =  $(".styles__tabby-promo-snippet__text--f30af").html();
  //  console.log(text);
  //  text = text.replace("or 4 interest-free payments of","Split in 4 Payments of");
  //  $(".styles__tabby-promo-snippet__text--f30af").html(text);
  // }, 500);
